export default __webpack_public_path__ + "static/windscribe-chrome-extension-001f77b40062ac2f8fc1f4b98ebde556.png";